import BigNumber from 'bignumber.js';
import { useNavigate } from 'react-router';
import { useBalance } from '@/hooks/useBalance';
import { useGetLeverage } from '@/components/trading/hooks/useGetLeverage';
import { usePrice } from '@/store/price';
import { Type } from '@/components/trading/type';
import { MAX_TP_PERCENT } from '@/components/trading/buy-sell/potential-earning';

const MAX_TRADE_PAIR_INDEX = 0;

/** Navigates to /future prefilled with max balance + max leverage (long/short suggestion). */
export function useTradeMax() {
    const navigate = useNavigate();
    const { data: balance } = useBalance();
    const { maxLeverage } = useGetLeverage(MAX_TRADE_PAIR_INDEX);

    return () => {
        if (balance === undefined) {
            navigate('/future');
            return;
        }
        const maxAmount = new BigNumber(balance.toString())
            .dividedBy(1e18)
            .decimalPlaces(2, BigNumber.ROUND_DOWN);
        const price24h = Number(
            usePrice.getState().data[String(MAX_TRADE_PAIR_INDEX)]?.price24h
        );
        const params = new URLSearchParams({
            pairIndex: String(MAX_TRADE_PAIR_INDEX),
            amount: maxAmount.toString(),
            leverage: String(maxLeverage),
            type: price24h < 0 ? Type.Short : Type.Long,
            tp: String(MAX_TP_PERCENT),
            suggest: '1',
        });
        navigate(`/future?${params.toString()}`);
    };
}
